@let list = list$ | async;

@if (list) {
    @for (item of list; track item.id) {
        <ng-template
            [ngTemplateOutlet]="itemTpl"
            [ngTemplateOutletContext]="{ item: item }"
        ></ng-template>
    }

    @if (currentPortionLoad < countPortionLoad || countListAll > limit) {
        <bazis-button
            *transloco="let t"
            fill="outline"
            color="action"
            class="bh-margin-top-3x"
            (click)="needNextPage$.next(true)"
        >
            <bazis-icon
                slot="start"
                name="rotate-right"
            ></bazis-icon>
            {{ t('action.loadMore', { count: limit }) }}
        </bazis-button>
    }
}
